var _defs, _polygon, _path, _path2, _polygon2, _polygon3, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJeffreyidleeyeballs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_7",
    "data-name": "Layer 7",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490.44 430.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #474748;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        fill: #6d6d6d;\n        stroke: #6d6d6d;\n      }\n\n      .cls-3 {\n        fill: #e9e9e9;\n        stroke: #e9e9e9;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "200.22 302.15 191.54 327.52 227.24 356.61 300.26 339 301.9 302.15 200.22 302.15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M205.53,317.59l-5.3,2.49s.87,4.53,4.11,5.66,10.27,1.34,10.27,1.34c0,0,11.45-.17,12.64-.94,2.57-1.67,2.57-7.86,2.57-7.86l-13.77-2.36-10.51,1.66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M287.37,317.59l5.3,2.49s-.87,4.53-4.11,5.66-10.27,1.34-10.27,1.34c0,0-11.45-.17-12.64-.94-2.57-1.67-2.57-7.86-2.57-7.86l13.77-2.36,10.51,1.66"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "277.87 315.93 279.66 321.46 276.51 326.15 267.51 325.31 266.23 319.94 269.82 316.66 277.87 315.93"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "215.01 315.93 213.23 321.46 216.38 326.15 225.37 325.31 226.65 319.94 223.07 316.66 215.01 315.93"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.05,326.15s1.66-1.31,2.1-3.34-.74-4.81-.74-4.81c0,0-3.32-3.57-5.6-4.07s-5.89,1.48-5.89,1.48c0,0-2.5,3.33-2.81,5.61-.43,3.2,3.42,6.5,3.42,6.5,0,0,3,1.04,4.79.76s4.72-2.13,4.72-2.13h.01Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.36,327.52s3.86-3.29,3.42-6.5c-.31-2.28-2.81-5.61-2.81-5.61,0,0-4.19-1.67-6.73-1.46s-4.76,4.05-4.76,4.05c0,0-1.17,2.77-.74,4.81s2.1,3.34,2.1,3.34c0,0,2.5,2.13,4.02,2.13s5.5-.76,5.5-.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJeffreyidleeyeballs);
export default __webpack_public_path__ + "static/media/jeffreyidleeyeballs.39f799289bf61b1fa0519d665c7ecb6c.svg";
export { ForwardRef as ReactComponent };